/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Component, HostBinding, Input, ChangeDetectionStrategy } from '@angular/core'

export enum PidxLoaderSizeEnum {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

export enum PidxLoaderModeEnum {
  INLINE = 'INLINE',
  OVERLAY = 'OVERLAY',
}

@Component({
  selector: 'pidx-loader',
  templateUrl: './pidx-loader.component.html',
  styleUrls: ['./pidx-loader.component.scss'],
  standalone: false,
  // Angular 22 changed the implicit default to OnPush (see angular/angular#67687). This component was never migrated
  // to OnPush semantics, so Eager restores the pre-v22 behaviour it relies on.
  // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class PidxLoaderComponent {
  /** Visible label rendered next to the spinner. */
  @Input() text?: string
  /**
   * Screen-reader-only label announced via the live region when no visible
   * `text` is shown (e.g. overlay/refresh spinners). Translated by the caller.
   */
  @Input() loadingLabel?: string
  @Input() mode: PidxLoaderModeEnum = PidxLoaderModeEnum.INLINE
  @Input() size?: PidxLoaderSizeEnum

  @HostBinding('attr.role') role = 'status'
  @HostBinding('attr.aria-live') ariaLive = 'polite'
  @HostBinding('attr.aria-busy') ariaBusy = 'true'

  @HostBinding('class.mode--overlay') get overlayClass() {
    return this.mode === PidxLoaderModeEnum.OVERLAY
  }
}
